<div class="bookmark-button__container" *ngIf="isDisplayed">
  <button
    data-automation-id="ap-show-bookmark-sidebar"
    class="bookmark-button"
    [class.active]="sidebarBookmark"
    (click)="showBookmark()"
  >
    <fa-icon class="icon bookmark-button__icon" [icon]="bookmarkIcon" size="sm"></fa-icon>
  </button>
  <button
    data-automation-id="ap-show-saved-search-sidebar"
    [class.active]="sidebarSavedSearch"
    (click)="showSavedSearch()"
    class="bookmark-button"
  >
    <span class="fas fa-search-plus icon" aria-hidden="true"></span>
  </button>
</div>
<app-ap-bookmark-sidebar [show]="sidebarBookmark"></app-ap-bookmark-sidebar>
<app-ap-saved-search-sidebar [show]="sidebarSavedSearch"></app-ap-saved-search-sidebar>

